function hasUserId(user) {
  const userId = user?.id;
  return userId !== undefined && userId !== null && String(userId).trim() !== "";
}

function isEligibleIntern(user) {
  return Boolean(user?.Intern) && Number(user?.Contracts) > 0 && hasUserId(user);
}

function getChangelogDismissalKey(version, userId) {
  return `intern.changelog.dismissed.${version}.${String(userId)}`;
}

function hasDismissedChangelog(storage, key) {
  if (!storage || !key) return false;
  try {
    return storage.getItem(key) === "true";
  } catch (_error) {
    return false;
  }
}

function dismissChangelog(storage, key) {
  if (!storage || !key) return false;
  try {
    storage.setItem(key, "true");
    return true;
  } catch (_error) {
    return false;
  }
}

function shouldShowChangelog(user, version, storage) {
  if (!isEligibleIntern(user)) return false;
  const key = getChangelogDismissalKey(version, user.id);
  return !hasDismissedChangelog(storage, key);
}

module.exports = {
  dismissChangelog,
  getChangelogDismissalKey,
  hasDismissedChangelog,
  hasUserId,
  isEligibleIntern,
  shouldShowChangelog,
};
